/* eslint-disable no-unused-vars */
/* eslint-disable no-restricted-syntax */
import React, { useState } from 'react';
import _ from 'lodash';
import { Button } from 'reactstrap';
import { db } from '../common/firebase';
import InputComponent from '../common/input';

const DebugPage = () => {
  const [data, setData] = useState();
  const [brandInput, setBrand] = useState('aston-martin');

  const downloadObjectAsJson = (exportObj, exportName) => {
    const dataStr = `data:text/json;charset=utf-8,${encodeURIComponent(
      JSON.stringify(exportObj)
    )}`;
    const downloadAnchorNode = document.createElement('a');
    downloadAnchorNode.setAttribute('href', dataStr);
    downloadAnchorNode.setAttribute('download', `${exportName}.json`);
    document.body.appendChild(downloadAnchorNode); // required for firefox
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
  };

  const fixAccess = async () => {
    try {
      console.log('Doing some housekeeping...');
      const result = [];

      const querySnapshot = await db
        .collection(`users`)
        .get()
        .catch((err) => console.error(err));

      const allAccess = await db
        .doc(`admin/1`)
        .get()
        .catch((err) => console.error(err));

      if (!allAccess) return console.error('NO CONTENT ON ADMIN');

      const { availableTree = {} } = allAccess.data() || {};

      const availableTreeObject = availableTree;
      const availableAccess = _.get(availableTreeObject, ['children']);

      querySnapshot.forEach((element) => {
        const userData = element.data();
        const { access } = userData;
        const accessObject = _.isObject(access) ? access : JSON.parse(access);
        const newAccess = JSON.parse(JSON.stringify(accessObject));

        accessObject.forEach((brandObject) => {
          brandObject.markets.forEach((marketObject) => {
            marketObject.languages.forEach((languageObject) => {
              const { brand } = brandObject;
              const { market } = marketObject;
              const language = languageObject.language
                ? languageObject.language
                : languageObject;

              const foundBrand = _.find(
                availableAccess,
                (availableBrands) => availableBrands.value === brand
              );
              if (foundBrand) {
                const foundMarket = _.find(
                  foundBrand.children,
                  (availableMarkets) => availableMarkets.value === market
                );
                if (foundMarket) {
                  const foundLanguage = _.find(
                    foundMarket.children,
                    (availableLanguages) =>
                      availableLanguages.value === language
                  );
                  if (!foundLanguage) {
                    result.push(
                      `have not found ${element.id} - ${brand} - ${market} - ${language}`
                    );
                    const newAccessBrand = _.find(newAccess, { brand });
                    const newAccessMarket = _.find(newAccessBrand.markets, {
                      market,
                    });

                    _.remove(newAccessMarket.languages, (languageObj) => {
                      if (languageObj.language) {
                        return languageObj.language === language;
                      }
                      return languageObj === language;
                    });

                    if (newAccessMarket.languages.length === 0)
                      _.remove(newAccessBrand.markets, { market });

                    if (newAccessBrand.markets.length === 0)
                      _.remove(newAccess, { brand });
                  }
                } else {
                  result.push(
                    `have not found ${element.id} -${brand} - ${market}`
                  );
                  const foundAccessBrand = newAccess.find(
                    (item) => item.brand === brand
                  );
                  if (foundAccessBrand) {
                    _.remove(foundAccessBrand.markets, { market });
                    if (foundAccessBrand.markets.length === 0) {
                      _.remove(newAccess, { brand });
                    }
                  }
                }
              } else if (brand) {
                result.push(`have not found ${element.id} -${brand}`);
                _.remove(newAccess, { brand });
              }
            });
          });
        });
        const strAccess = JSON.stringify(newAccess);
        db.doc(`users/${element.id}`).set(
          { access: strAccess },
          { merge: true }
        );
      });
      return;
    } catch (error) {
      console.log(error);
    }
    return;
  };

  const getAvailableMarkets = async (brand) => {
    const dataRef = await db.doc(`admin/1`).get();

    const res = dataRef.data();
    const markets = res.availableTree.children.find(
      (item) => item.value === brand
    );

    if (!markets) {
      console.log({ message: 'brand not found', brand, res });
    }

    return markets;
  };

  const saveChanges = (
    translation,
    savedFrom,
    saveUser,
    brand,
    market,
    language
  ) => {
    const docReferenceTrans = db.doc(
      `brand/${brand.toLowerCase()}/market/${market.toLowerCase()}/language/${language
        .toLowerCase()
        .replace('_', '-')}`
    );
    return docReferenceTrans.set(
      {
        saved: Object.assign({}, translation),
        lastSaveDate: Date.now(),
        savedFrom,
        saveUser,
      },
      { merge: true }
    );
  };

  const fixConfiguration = async (brand, market, language) => {
    const dataRef = await db
      .doc(`brand/${brand}/market/${market}/language/${language}`)
      .get();

    const res = dataRef.data();
    if (!res) {
      console.warn({
        message: 'language saving not found',
        brand,
        market,
        language,
        res,
      });
      return;
    }

    try {
      const { saved } = res;
      const vdpPage =
        saved.pages['VDP Page']['d801b50b-3861-4946-9cc0-d7d8d5d93600'];
      const benefitsModule =
        saved.pages['VDP Page']['95b52c3c-8547-11ec-a8a3-0242ac120002'];

      if (!benefitsModule) {
        console.warn({
          message: 'benefits not found',
          brand,
          market,
          language,
          res,
        });
        return;
      }

      const newText = {
        BenefitsHeadLineText: benefitsModule.headLineText,
        BenefitsSubHeadlineText: benefitsModule.subHeadlineText,
        Benefits360descriptionItemText: benefitsModule['0'].descriptionItemText,
        Benefits360titleItemText: benefitsModule['0'].titleItemText,
        BenefitsAssistanceDescriptionItemText:
          benefitsModule['5'].descriptionItemText,
        BenefitsAssistanceTitleItemText: benefitsModule['5'].titleItemText,
        BenefitsRestoredDescriptionItemText:
          benefitsModule['1'].descriptionItemText,
        BenefitsRestoredTitleItemText: benefitsModule['1'].titleItemText,
        BenefitsServicingDescriptionItemText:
          benefitsModule['4'].descriptionItemText,
        BenefitsServicingTitleItemText: benefitsModule['4'].titleItemText,
        BenefitsWarrantyDescriptionItemText:
          benefitsModule['3'].descriptionItemText,
        BenefitsWarrantyTitleItemText: benefitsModule['3'].titleItemText,
        BenefitsWhispersDescriptionItemText:
          benefitsModule['2'].descriptionItemText,
        BenefitsWhispersTitleItemText: benefitsModule['2'].titleItemText,
      };

      saved.pages['VDP Page']['d801b50b-3861-4946-9cc0-d7d8d5d93600'] = {
        ...vdpPage,
        ...newText,
      };

      saveChanges(
        saved,
        res.savedFrom,
        'diquattro@gmail.com',
        brand,
        market,
        language
      );

      console.log({
        message: `Fixing ${brand}-${market}-${language}`,
        object: newText,
      });
    } catch (error) {
      console.error({ brand, market, language, res, error });
    }

    // downloadObjectAsJson(data, `${brand}${market}${language}.json`);
  };

  const copyConfiguration = async (from, to) => {
    const dataRef = await db
      .doc(
        `brand/${from.brand}/market/${from.market}/language/${from.language}`
      )
      .get();

    const res = dataRef.data();
    if (!res) {
      console.warn({
        message: 'language saving not found',
        res,
      });
      return;
    }

    try {
      const { saved } = res;

      saveChanges(
        saved,
        res.savedFrom,
        'diquattro@gmail.com',
        to.brand,
        to.market,
        to.language
      );

      // console.log({
      //   message: `Fixing ${brand}-${market}-${language}`,
      //   object: newText,
      // });
    } catch (error) {
      console.error({ error });
    }
  };

  const run = async () => {
    await fixAccess();
  };

  return (
    <div style={{ margin: 50 }}>
      <InputComponent
        name='brand'
        onChange={({ target }) => {
          setBrand(target.value);
        }}
        label='Brand'
        value={brandInput}
      />
      <Button onClick={run}>Run</Button>
      <code className='prettyprint'>{JSON.stringify(data)}</code>
    </div>
  );
};

export default DebugPage;
